function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, n) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = n() : "function" == typeof define && define.amd ? define(n) : (e = e || self).vueDebounce = n();
}(this, function () {
  "use strict";

  function d(t, e) {
    var n,
        o,
        i,
        r = null,
        u = (n = String(e).split(/(ms|s)/i), o = n[0], void 0 === (i = n[1]) && (i = "ms"), Number(o) * {
      ms: 1,
      s: 1e3
    }[i]),
        c = function c() {
      for (var e = [], n = arguments.length; n--;) {
        e[n] = arguments[n];
      }

      clearTimeout(r), (r = setTimeout(function () {
        r = null, t.apply(void 0, e);
      }, u)) || t.apply(void 0, e);
    };

    return c.cancel = function () {
      clearTimeout(r), r = null;
    }, c;
  }

  return {
    name: "debounce",
    install: function install(e, n) {
      void 0 === n && (n = {});
      var a = n.lock,
          l = n.listenTo;
      void 0 === l && (l = "onkeyup");
      var f = n.defaultTime;
      void 0 === f && (f = "300ms"), e.directive("debounce", {
        bind: function bind(n, e) {
          var i = e.value,
              t = e.arg,
              r = e.modifiers,
              o = function (e, n) {
            var t = (e.getNamedItem("debounce-events") || {}).value;
            void 0 === t && (t = !1);

            var o = Array.isArray(n),
                i = function i(e) {
              return e.map(function (e) {
                return e.toLowerCase();
              });
            };

            return t ? i(t.split(",")) : o ? i(n) : [n];
          }(n.attributes, l),
              u = d(function (e) {
            i(e.value);
          }, t || f);

          function c(e) {
            var n = e.key,
                t = e.target,
                o = !r.lock && !a || r.unlock;
            "Enter" === n && o && (u.cancel(), i(t.value)), "Enter" !== n && u(t);
          }

          o.forEach(function (e) {
            if (void 0 === n[e]) throw new Error("Event Listener " + e + " does not exist");
            n[e] = c;
          });
        }
      });
    }
  };
});